import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectSelectedItem, selectItemsForParent, selectProjectId } from '@/store/selectors';
import { setSelectedItem } from '../../app/features/project/projectSlice';
import { Message } from './components/Message';
import type { NormalizedItem } from '@/components/itemList/types';

interface TaskMessage {
  content: string;
  created: string;
  sender: string;
  userData?: { given_name?: string; family_name?: string; img?: string };
}

interface Task {
  id: string;
  resource: string;
  type: string;
  taskType: string;
  timestamp?: number;
  owner: string;
  messages: TaskMessage[];
}

interface ProjectChatTasksProps {
  tasks: Task[];
  updateSelectedTask: (task: Task) => void;
  isVisible: boolean;
  projectId: string;
  uid: string | null;
  userRole: string | null;
  updateModalOpen: (type: string, params?: Record<string, unknown>) => void;
}

export function ProjectChatTasks({
  tasks,
  updateSelectedTask,
  isVisible,
  projectId,
  uid,
  userRole,
  updateModalOpen,
}: ProjectChatTasksProps) {
  const dispatch = useAppDispatch();
  const selectedItem = useAppSelector(selectSelectedItem) as NormalizedItem | null;
  const reduxProjectId = useAppSelector(selectProjectId) as string | null;
  const items = useAppSelector(selectItemsForParent(reduxProjectId)) as NormalizedItem[] | undefined;

  return (
    <ul className={isVisible ? '' : 'hidden'}>
      {tasks.map((task) =>
        task.messages.map((message, index) => {
          const isFirst = index === 0;
          const imageUrl = isFirst
            ? items?.find((i) => i.id === task.resource)?.thumbnailUrl
            : message.userData?.img;

          return (
            <li key={message.created}>
              <Message
                firstName={message.userData?.given_name}
                lastName={message.userData?.family_name}
                created={message.created}
                content={message.content}
                image={{ task: isFirst, imageUrl }}
                isAReply={!isFirst}
                task={task}
                previewItemOnShow={selectedItem ?? undefined}
                taskResource={items?.find((i) => i.id === task.resource)}
                updateSelectedTask={updateSelectedTask}
                isRemovable={isFirst && (userRole === 'admin' || uid === task.owner) && !!task.id}
                projectId={projectId}
                updateModalOpen={updateModalOpen}
              />
            </li>
          );
        }),
      )}
    </ul>
  );
}
